const validate = (values) => {
  // console.log(values);
  const errors = {};
  if (!values.customLabelName || values.customLabelName.trim() === '') {
    errors.customLabelName = 'Please enter custom field name';
  }
  if (!values.roleTypeId) {
    errors.roleTypeId = 'Please choose a role to link';
  } else if (!Number.isInteger(values.roleTypeId)) {
    errors.roleTypeId = 'Please select an option';
  }

  return errors;
};
export default validate;



// WEBPACK FOOTER //
// ./src/modules/Masters/components/customFields/validate.js